<section class="dashboard">
  <div class="dashboard-main">
    <header class="dashboard-header">
      <div>
        <h1>DIY Orders</h1>
      </div>
      <input
        class="search"
        type="search"
        placeholder="Search order #, customer, email…"
        [value]="search()"
        (input)="setSearch($any($event.target).value)"
      />
    </header>

    <div class="stats-row">
      <div class="stat-card">
        <div class="stat-value">{{ stats().inProgress }}</div>
        <div class="stat-label">In Progress</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">{{ stats().complete }}</div>
        <div class="stat-label">Complete</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">{{ stats().total }}</div>
        <div class="stat-label">Total</div>
      </div>
    </div>

    <div class="tabs">
      @for (tab of tabs; track tab.value) {
        <button
          class="tab-btn"
          [class.active]="activeTab() === tab.value"
          (click)="selectTab(tab.value)"
        >
          {{ tab.label }}
        </button>
      }
    </div>

    @if (pageRows().length === 0) {
      <div class="empty-state">
        {{ search() ? "No orders match your search." : "No orders here." }}
      </div>
    } @else {
      <div class="list">
        <div class="list-head">
          <span>Order</span>
          <span>Customer</span>
          <span>Status</span>
          <span>Payment</span>
          <span>Progress</span>
          <span class="num">Total</span>
          <span>Date</span>
          <span></span>
        </div>
        @for (o of pageRows(); track o.id) {
          <a class="list-row" [routerLink]="['/orders', o.id]">
            <span class="cell strong">{{ o.orderNumber ?? o.id }}</span>
            <span class="cell customer">
              <span class="strong">{{ o.customerName || "—" }}</span>
              <span class="muted">{{ o.customerEmail }}</span>
            </span>
            <span class="cell">
              <span class="status-badge">{{ statusLabel(o.status) }}</span>
            </span>
            <span class="cell">
              <span class="pay-badge" [class.paid]="o.paymentStatus === 'paid'">
                {{ o.paymentStatus === "paid" ? "Paid" : "Pending" }}
              </span>
            </span>
            <span class="cell progress-cell">
              <span class="bar"><span [style.width.%]="progress(o)"></span></span>
              <span class="muted">{{ progress(o) }}%</span>
            </span>
            <span class="cell num strong">{{ money(o.total) }}</span>
            <span class="cell muted">{{ o.createdAt | date: "mediumDate" }}</span>
            <span class="cell chev">›</span>
          </a>
        }
      </div>

      <footer class="pager">
        <span class="pager-info">{{ total() }} orders</span>
        <div class="pager-controls">
          <button type="button" (click)="setPage(-1)" [disabled]="page() === 0">
            ‹ Prev
          </button>
          <span class="pager-page">{{ page() + 1 }} / {{ pageCount() }}</span>
          <button
            type="button"
            (click)="setPage(1)"
            [disabled]="page() >= pageCount() - 1"
          >
            Next ›
          </button>
        </div>
      </footer>
    }
  </div>
</section>
